import React from 'react';

interface SoftTronikConfigurationProps {
    configuration: {
        BaseUrl?: string;
        ContactPersonKey?: string;
        ContractKey?: string;
        Warehouses?: string;
    };
    onChange: (field: string, value: string | number) => void;
    disabled?: boolean;
}

interface SoftTronikConfigurationComponent extends React.FC<SoftTronikConfigurationProps> {
    configFields: string[];
}

const SoftTronikConfiguration: SoftTronikConfigurationComponent = ({
    configuration,
    onChange,
    disabled = false
}) => {
    return (
        <React.Fragment>
            <div className="form-group-custom" style={{ gridColumn: '1 / -1' }}>
                <label className="form-label-custom">
                    <span className="label-icon">🌐</span>
                    Базовый URL
                </label>
                <div className="input-group-custom">
                    <input
                        type="url"
                        className="form-input-custom"
                        value={configuration.BaseUrl || ''}
                        onChange={(e) => onChange('BaseUrl', e.target.value)}
                        placeholder="https://api.softtronik.example.com"
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">👤</span>
                    Contact Person Key
                </label>
                <div className="input-group-custom">
                    <input
                        type="text"
                        className="form-input-custom"
                        value={configuration.ContactPersonKey || ''}
                        onChange={(e) => onChange('ContactPersonKey', e.target.value)}
                        placeholder="Ключ контактного лица"
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">📋</span>
                    Contract Key
                </label>
                <div className="input-group-custom">
                    <input
                        type="text"
                        className="form-input-custom"
                        value={configuration.ContractKey || ''}
                        onChange={(e) => onChange('ContractKey', e.target.value)}
                        placeholder="Ключ контракта"
                        disabled={disabled}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

// Define the configuration fields used by this supplier
SoftTronikConfiguration.configFields = ['BaseUrl', 'ContactPersonKey', 'ContractKey'];

export default SoftTronikConfiguration;
